import { useEffect, useState } from "react";
import { getTablaResumen } from "../services/alertasGenericasService";

const totalesVacios = { verde: 0, amarillo: 0, rojo: 0 };

export const useTablaResumen = (anio, semestre, programa, competencia = "RC") => {
  const [filas, setFilas] = useState([]);
  const [totales, setTotales] = useState(totalesVacios);
  const [totalEstudiantes, setTotalEstudiantes] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let isMounted = true;
    setLoading(true);

    getTablaResumen({ anio, semestre, programa, competencia }).then((result) => {
      if (!isMounted) return;
      const payload = result || { filas: [], totales: totalesVacios, total_estudiantes: 0 };
      setFilas(Array.isArray(payload.filas) ? payload.filas : []);
      setTotales(payload.totales || totalesVacios);
      setTotalEstudiantes(Number(payload.total_estudiantes) || 0);
      setLoading(false);
    });

    return () => {
      isMounted = false;
    };
  }, [anio, semestre, programa, competencia]);

  return { filas, totales, totalEstudiantes, loading };
};
